// src/services/mlApi.js
import { API_BASE_URL_NO_PATH } from "../config/apiConfig";

export const API_BASE = API_BASE_URL_NO_PATH;

console.log("[mlApi] API_BASE =", API_BASE);

export async function postWalkforward(payload) {
  const r = await fetch(`${API_BASE}/api/ml/walkforward`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!r.ok) {
    const t = await r.text().catch(() => "");
    throw new Error(`ML walkforward failed (${r.status}): ${t || r.statusText}`);
  }
  return r.json();
}

export async function postPrediction(payload) {
  const r = await fetch(`${API_BASE}/api/ml/predict`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!r.ok) {
    const t = await r.text().catch(() => "");
    throw new Error(`Prediction failed (${r.status}): ${t || r.statusText}`);
  }
  return r.json();
}

/** LightGBM prediction: fundamentals + price + date -> probability of return buckets. */
export async function postPredictLgbm({ symbol, selected_features }) {
  const r = await fetch(`${API_BASE}/api/ml/predict-lgbm`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ symbol: (symbol || "").trim().toUpperCase(), selected_features: selected_features || [] }),
  });
  if (!r.ok) {
    const t = await r.text().catch(() => "");
    throw new Error(`LightGBM prediction failed (${r.status}): ${t || r.statusText}`);
  }
  return r.json();
}

/** LightGBM regression: expanding-year backtest + forward forecast (with +/-1 std). */
export async function postPredictLgbmRegression({ symbol, selected_features, forecast_days = 252, use_price_action = true }) {
  const r = await fetch(`${API_BASE}/api/ml/predict-lgbm-regression`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      symbol: (symbol || "").trim().toUpperCase(),
      selected_features: selected_features || [],
      forecast_days,
      use_price_action,
    }),
  });
  if (!r.ok) {
    const t = await r.text().catch(() => "");
    throw new Error(`LightGBM regression failed (${r.status}): ${t || r.statusText}`);
  }
  return r.json();
}